export default __webpack_public_path__ + "static/media/README.dd7bea95.md";